import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router'

import { yupResolver } from '@hookform/resolvers/yup'
import { Button } from '@ui/components/core'
import axios from '@ui/lib/api/axiosHelper'
import { useAuth } from '@ui/providers/AuthProvider'
import * as Yup from 'yup'

import { ExistingOrganizations } from './ExistingOrganizations'

export const CreateOrganization = () => {
  const navigate = useNavigate()
  const auth = useAuth()

  const [organizationName, setOrganizationName] = useState('')

  const schema = Yup.object({
    oganizationName: Yup.string().required('Organization name required'),
  })

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })

  const sendToServer = ({ oganizationName }: { oganizationName: string }) => {
    console.log('sendToServer', oganizationName)
    const newOrganization = {
      organization: {
        name: oganizationName,
      },
    }

    // This also sets the org for the user
    axios
      .post('/v1/organizations', newOrganization)
      .then((response) => {
        if (response.status === 201) {
          auth.restoreSession(() => {
            navigate('/setup')
          })
        } else {
          setError('oganizationName', { message: 'An error occurred' })
        }
      })
      .catch((error) => {
        const { response } = error
        const { data } = response
        const { errors } = data

        if (errors?.slug) {
          setError('oganizationName', { message: `Name ${errors.slug.join(', ')}` })
        } else {
          setError('oganizationName', { message: 'Oh no, an error occurred' })
        }
      })
  }

  const isDisabled = organizationName.length === 0

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center space-y-4">
      <h1 className="text-4xl font-semibold text-secondary-800">Create your organization</h1>
      <p className="text-base font-normal text-gray-600">Name your organization and start transforming your data.</p>
      <form onSubmit={handleSubmit(sendToServer)} className="flex flex-col items-center justify-center space-y-4">
        <div className="w-96">
          <input
            {...register('oganizationName')}
            type="text"
            name="oganizationName"
            id="oganizationName"
            onChange={(e) => setOrganizationName(e.target.value)}
            className="mt-2 block w-full rounded-md border-0 bg-white text-gray-600 shadow-sm outline-none ring-1 ring-inset ring-gray-300 transition-all duration-300 ease-in-out placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-primary-200 sm:text-sm sm:leading-6"
            placeholder="Acme Inc."
          />
          {errors.oganizationName && (
            <p className="mt-2 text-xs italic text-red-500">{errors.oganizationName?.message}</p>
          )}
        </div>
        <Button type="submit" disabled={isDisabled}>
          Create organization
        </Button>
      </form>
      <p className="text-sm text-gray-600">Or join an existing organization</p>
      <ExistingOrganizations />
    </div>
  )
}
